
<template lang="pug">
div
  template(v-if="disabled")
    slot
  template(v-else)
    .DropFile__container(
      @dragenter="onDragEnter()"
      @dragover.prevent="onDragOver()"
      @dragleave="onDragLeave()"
      @drop.prevent="onDrop()"
    )
      slot
      label.DropFile__input-label
        input.DropFile__input(
          type="file"
          @change="onInputChange"
        )
      .DropFile__overlay(v-if="dragover")
</template>

<script>
export default {
  props: {
    disabled: {default: false},
  },

  data() {
    return {
      dragover: false,
      inputValue: '',
    }
  },

  methods: {
    // ファイルなどをドロップする要素が子要素を持っていても正しくホバーエフェクトを表示する方法
    // 参考: https://qiita.com/sounisi5011/items/dc4878d3e8b38101cf0b

    onDragEnter() {
      this.dragToInner = true
    },

    onDragOver() {
      this.dragToInner = false
      this.dragover = true
    },

    onDragLeave() {
      if(!this.dragToInner) {
        this.dragover = false
      }
      this.dragToInner = false
    },

    onDrop() {
      this.dragover = false
      this.$emit('drop', event.dataTransfer.files)
    },

    onInputChange() {
      this.$emit('drop', event.target.files)
      event.target.value = ''
    },
  },
}
</script>

<style lang="sass">
.DropFile__container
  position: relative

.DropFile__input-label
  cursor: pointer
  height: 100%
  left: 0
  position: absolute
  top: 0
  width: 100%

.DropFile__input
  height: 0
  left: 0
  opacity: 0
  outline: none
  overflow: hidden
  position: absolute
  top: 0
  width: 0

.DropFile__overlay
  background-color: black
  bottom: 0
  left: 0
  opacity: .5
  position: absolute
  right: 0
  top: 0
</style>
